/* One-tap quick add for product cards. Delegated so re-rendered cards keep working.
   Adds via the Cart AJAX API and refreshes the header count from the
   cart-icon-bubble section (same mechanism Dawn's cart JS uses), with a
   /cart.js fallback if the section payload is missing. */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setBubble(html) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !html) return false;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var section = tmp.querySelector('.shopify-section') || tmp.firstElementChild;
    if (!section) return false;
    bubble.innerHTML = section.innerHTML;
    bumpCount();
    return true;
  }

  function bumpCount() {
    var count = document.querySelector('#cart-icon-bubble .l3d-hdr__cart-count');
    if (count) {
      count.classList.remove('l3d-qa-bump');
      void count.offsetWidth;
      count.classList.add('l3d-qa-bump');
    }
  }

  function fallbackCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        var count = bubble.querySelector('.l3d-hdr__cart-count');
        if (cart.item_count > 0) {
          if (!count) {
            count = document.createElement('span');
            count.className = 'l3d-hdr__cart-count';
            count.setAttribute('aria-hidden', 'true');
            bubble.appendChild(count);
          }
          count.textContent = cart.item_count;
          bumpCount();
        } else if (count) {
          count.remove();
        }
      })
      .catch(function () {});
  }

  /* Session flag for the STL acknowledgement (digital waiver + printer size).
     sessionStorage can throw in some privacy modes; fall back to an in-memory flag. */
  var stlAckMemory = false;
  function stlAckGiven() {
    if (stlAckMemory) return true;
    try { return sessionStorage.getItem('l3dStlAck') === '1'; } catch (err) { return false; }
  }
  function setStlAck() {
    stlAckMemory = true;
    try { sessionStorage.setItem('l3dStlAck', '1'); } catch (err) {}
  }

  function openStlAckModal(btn) {
    var existing = document.querySelector('.l3d-qa-modal');
    if (existing) existing.remove();
    var overlay = document.createElement('div');
    overlay.className = 'l3d-qa-modal';
    overlay.innerHTML =
      '<div class="l3d-qa-modal__box" role="dialog" aria-modal="true" aria-label="Before these files go in your cart">' +
        '<p class="l3d-qa-modal__title">Quick check before these files go in your cart</p>' +
        '<ul class="l3d-qa-modal__list">' +
          '<li>These are <strong>instant digital downloads</strong>. Nothing physical is posted. Files are supplied immediately after checkout and I agree that I lose my 14 day right to cancel once delivery begins, so <strong>digital files are non-refundable</strong>. This does not affect my rights if a file is faulty.</li>' +
          '<li>Every jig comes two ways: <strong>one piece</strong> for large printers, or <strong>split into two halves</strong> that print on any machine. Each half is <strong>155 x 125mm</strong> (about 6 x 5 inches), which fits a Bambu A1 mini and just about anything bigger.</li>' +
        '</ul>' +
        '<label class="l3d-qa-modal__ack"><input type="checkbox" class="l3d-qa-modal__tick"> I understand and agree</label>' +
        '<div class="l3d-qa-modal__actions">' +
          '<button type="button" class="l3d-qa-modal__cancel">Cancel</button>' +
          '<button type="button" class="l3d-qa-modal__confirm" disabled>Add to cart</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);
    var tick = overlay.querySelector('.l3d-qa-modal__tick');
    var confirm = overlay.querySelector('.l3d-qa-modal__confirm');
    var cancel = overlay.querySelector('.l3d-qa-modal__cancel');
    function close() {
      overlay.remove();
      document.removeEventListener('keydown', onKey);
    }
    function onKey(ev) { if (ev.key === 'Escape') close(); }
    document.addEventListener('keydown', onKey);
    overlay.addEventListener('click', function (ev) { if (ev.target === overlay) close(); });
    cancel.addEventListener('click', close);
    tick.addEventListener('change', function () { confirm.disabled = !tick.checked; });
    confirm.addEventListener('click', function () {
      if (!tick.checked) return;
      setStlAck();
      close();
      doAdd(btn);
    });
    tick.focus();
  }

  function announce(text) {
    var live = document.getElementById('l3d-qa-live');
    if (!live) {
      live = document.createElement('div');
      live.id = 'l3d-qa-live';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;';
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 50);
  }

  function doAdd(btn) {
    if (btn.classList.contains('is-busy')) return;
    btn.classList.remove('is-added', 'is-error');
    btn.classList.add('is-busy');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [btn.dataset.l3dQaAck
          ? { id: parseInt(btn.dataset.variantId, 10), quantity: 1, properties: { '_Digital waiver agreed': 'Yes, in the quick add check, ' + new Date().toISOString().slice(0, 10) } }
          : { id: parseInt(btn.dataset.variantId, 10), quantity: 1 }],
        sections: 'cart-icon-bubble'
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function (data) {
        var ok = data && data.sections && setBubble(data.sections['cart-icon-bubble']);
        if (!ok) fallbackCount();
        btn.classList.add('is-added');
        announce('Added to cart');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
      })
      .catch(function () {
        btn.classList.add('is-error');
        announce('Could not add to cart. Please try again.');
        setTimeout(function () { btn.classList.remove('is-error'); }, 2200);
      })
      .then(function () { btn.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-l3d-qa]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.dataset.l3dQaAck && !stlAckGiven()) {
      openStlAckModal(btn);
      return;
    }
    doAdd(btn);
  });
})();
